import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { useFormik } from 'formik';

import { validationSchema } from '../../../../../forms/bannerSettingForm';
import BannerSettingsPresenter from '../../../../../presenters/BannerSettingsPresenter';
import { apiErrorsToFormik } from '../../../../../utils/formUtils';
import Label from '../../../../../components/Label';
import Row from '../../../../../components/Row';
import Column from '../../../../../components/Column';
import Input from '../../../../../components/Input';
import Button from '../../../../../components/Button';

import Images from './components/Images';
import ColorInputs from './components/ColorInputs';
import BannerTypeSelect from './components/BannerTypeSelect';

const EditSettingForm = (props) => {
  const { initialValues, onSubmit, onModalClose, apiErrors } = props;

  const formik = useFormik({
    initialValues,
    onSubmit,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { handleSubmit, values, setFieldValue, errors, setErrors } = formik;

  const handleSettingChange = ({ target }) => {
    const { id, value } = target;
    setFieldValue(id, value);
  };

  const handleImageUploaded = (image) => {
    setFieldValue('image', image);
  };

  useEffect(() => {
    if (!isNil(apiErrors)) {
      setErrors(apiErrorsToFormik(apiErrors));
    }
    return () => {
      setErrors({});
    };
  }, [apiErrors]);

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Column>
          <BannerTypeSelect
            id="bannerType"
            defaultValue={values.bannerType}
            onChange={handleSettingChange}
            textLabel="Banner Type"
            errors={errors}
          />
          <div>
            <Label name="title" title="Title" errors={errors} />
            <Input
              id="title"
              value={values.title}
              onChange={handleSettingChange}
            />
          </div>
          <div>
            <Label name="text" title="Text" errors={errors} />
            <textarea
              id="text"
              value={values.text}
              onChange={handleSettingChange}
            />
          </div>

          <ColorInputs
            id="fontColor"
            textLabel="Font color"
            value={values.fontColor}
            onChange={handleSettingChange}
            errors={errors}
          />
          <ColorInputs
            id="backgroundColor"
            textLabel="Background Color"
            value={values.backgroundColor}
            onChange={handleSettingChange}
            errors={errors}
          />
          <div>
            <Label
              name="submitButtonText"
              title="Submit Button Text"
              errors={errors}
            />
            <Input
              type="text"
              id="submitButtonText"
              value={values.submitButtonText}
              onChange={handleSettingChange}
            />
          </div>
          <ColorInputs
            id="submitButtonColor"
            textLabel="Submit Button Color"
            value={values.submitButtonColor}
            onChange={handleSettingChange}
            errors={errors}
          />
          <Images
            error={errors}
            imageUrl={values.imageUrl}
            onImageUploaded={handleImageUploaded}
          />
        </Column>
      </Row>
      <div className="modal-actions">
        <Button className="modal-save" type="submit">
          Update
        </Button>
        <Button className="modal-close" onClick={onModalClose}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default EditSettingForm;

EditSettingForm.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  initialValues: BannerSettingsPresenter.shape().isRequired,
  apiErrors: PropTypes.shape(),
  onSubmit: PropTypes.func.isRequired,
};

EditSettingForm.defaultProps = {
  apiErrors: {},
};
